import { StateCreator } from "zustand";
import { ObservabilityData, ObservabilitySlice } from "./ObservabilityTypes";
import { UploadMethod } from "src/utils/observability/metrics/product-upload/productUploadTypes";

type ImmerStateCreator<T> = StateCreator<
  T,
  [["zustand/immer", never], never],
  [],
  T
>;

export const OBSERVABILITY_SLICE_ACTIONS = {
  SET_UPLOAD_ID: "SET_UPLOAD_ID",
  SET_UPLOAD_START_TIME: "SET_UPLOAD_START_TIME",
  ADD_USED_METHOD: "ADD_USED_METHOD",
  REMOVE_OBSERVABILITY: "REMOVE_OBSERVABILITY",
} as const;

const initialState: ObservabilityData = {
  uploadId: undefined,
  uploadStartTime: undefined,
  usedMethods: [],
};

export const createObservabilitySlice: ImmerStateCreator<ObservabilitySlice> = (
  set,
) => ({
  observabilityData: initialState,
  SET_UPLOAD_ID: (uploadId: string) => {
    set(
      (state) => {
        state.observabilityData.uploadId = uploadId;
      },
      false,
      OBSERVABILITY_SLICE_ACTIONS.SET_UPLOAD_ID,
    );
  },
  SET_UPLOAD_START_TIME: (startTime: number) => {
    set(
      (state) => {
        state.observabilityData.uploadStartTime = startTime;
      },
      false,
      OBSERVABILITY_SLICE_ACTIONS.SET_UPLOAD_START_TIME,
    );
  },
  ADD_USED_METHOD: (method: UploadMethod) => {
    set(
      (state) => {
        if (!state.observabilityData.usedMethods.includes(method)) {
          state.observabilityData.usedMethods.push(method);
        }
      },
      false,
      OBSERVABILITY_SLICE_ACTIONS.ADD_USED_METHOD,
    );
  },
  REMOVE_OBSERVABILITY: () => {
    set(
      (state) => {
        state.observabilityData = initialState;
      },
      false,
      OBSERVABILITY_SLICE_ACTIONS.REMOVE_OBSERVABILITY,
    );
  },
});
